import React from "react";
import { useCphDataContext } from "../hooks/useCphDataContext";
import { Box, Container, CardContent, Typography, Stack } from "@mui/material";
import { useCphContext } from "../hooks/useCphContext";
import IssueOverviewCard from "./cards/IssueOverviewCard";
import StaffEditCard from "./cards/StaffEditCard";
import DescriptionCard from "./cards/DescriptionCard";
import CommentCollectionCard from "./cards/CommentCollectionCard";
import AddCommentCard from "./cards/AddCommentCard";
import TitleCard from "./cards/TitleCard";
import UploadCard from "./cards/UploadCard";

const Issue: React.FC = () => {
    const { selectedIssue } = useCphDataContext();
    const { isStaff } = useCphContext();

    if (!selectedIssue) {
        return <Typography variant="body1">No issue selected.</Typography>;
    }

    return (
        <Container disableGutters maxWidth={false} sx={{ width: '100%', height: '100%', p: 0, m: 0 }}>
            <Box sx={{ width: '100%', height: '100%', maxWidth: '100%', mx: 0, px: 0, py: 0, }}>
                <CardContent>
                    <Stack spacing={2}>
                        <TitleCard />
                        {isStaff ? <StaffEditCard /> : null}
                        <IssueOverviewCard />
                        <DescriptionCard />
                        <CommentCollectionCard />
                        <UploadCard />
                        {selectedIssue.status?.status !== "Closed" ? <AddCommentCard /> : null}
                    </Stack>
                </CardContent>
            </Box>
        </Container>
    );
};

export default Issue;
